
    <set-widget
      [entity]="this.entity"
      [layout]="this.layout"
      [options]="options"
      [title]="'Trigger Events'"
    ></set-widget>
  